import {
  apiRoutes,
  httpClient,
  // getInfinitePromotionsFn,
  PAGE_INDEX,
} from '@ahm/api-wrappers-core';
import { useInfiniteQuery } from '@tanstack/react-query';
import { stringify } from 'qs';

export const getInfinitePromotionsFn = async ({
  pageParam = PAGE_INDEX,
  ...params
}) => {
  const response = await httpClient.get(apiRoutes.promotion.list_promotions, {
    params: {
      ...params,
      page: pageParam,
    },
    paramsSerializer: (p) =>
      stringify(p, {
        encode: false,
        arrayFormat: 'comma', // 👈 this turns arrays into "A,B,C"
        serializeDate: (d) => d.toISOString(),
      }),
  });

  return response.data;
};
export const useGetInfinitePromotions = (params) =>
  useInfiniteQuery({
    queryKey: ['infinity-promos', params],
    queryFn: ({ pageParam = PAGE_INDEX }) =>
      getInfinitePromotionsFn({
        ...params,
        pageParam,
      }),
    initialPageParam: PAGE_INDEX,

    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || lastPage.length === 0) {
        return undefined;
      }
      return allPages.length;
    },
    refetchOnWindowFocus: true,
  });
